<script setup lang="ts">
// プロップの定義
defineProps<{
	message?: string;
}>();
</script>

<template>
  <div class="interact-form thank-you-form">
    <h1 class="form-title">ご回答ありがとうございました。</h1>
    <p class="thank-you-message">{{ message || '担当者より折り返しご連絡いたします。' }}</p>
  </div>
</template>

<style lang="scss" scoped>
.thank-you-form {
  padding: 40px 20px;
  border-radius: 8px;
  max-width: 900px;
  margin: 32px auto;
  text-align: center;
  background-color: #f8f8f8;
  border: 6px solid #a5dbdf;
}

.thank-you-message {
  font-size: 18px;
  margin: 20px 0;
  color: #333;
}

.form-title {
  font-size: 28px;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 20px;
  text-align: center;
  padding: 0 48px;
  position: relative;
}

@media screen and (max-width: 767px) {
  .thank-you-form {
    padding: 25px 15px;
  }

  .thank-you-message {
    font-size: 16px;
    margin: 15px 0;
  }

  .form-title {
    font-size: 18px;
    margin-top: 15px;
    margin-bottom: 12px;
    padding: 0 15px;
  }
}
</style>
